export default __webpack_public_path__ + "static/media/horizontal_belonging.65bd0529.jpg";